import React, { useEffect, useRef, useState } from 'react'
import AstrologerAfterLoginHeader from '../astrologer_after_login_header/Astrologer_after_Login_Header'
import Loader from '../../../../loader/Loader'
import AstrologerFooter from '../astrologer_footer/Astrologer_Footer'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import { Add_Astrologer_Bank_Details, Get_Astrologer_Bank_Details } from '../../../../api/astrologer/Astrologer';
import { isAlphabetical, isIFSCCode } from '../../../validation/Validation';

const Astrologer_Bank_Deatils = () => {
    const [error, set_Error] = useState({})
    const [is_loading, set_Is_Loading] = useState(false)
    const [add_new_bank_details, set_Add_New_Address_Form_Data] = useState({
        holder_name: "",
        bank_name: "",
        account_no: "",
        retype_account_no: "",
        account_type: "",
        ifsc: "",
    })
    const [isDirty, setIsDirty] = useState(false);

    const isDirtyRef = useRef(false);
    const hasBackGuardRef = useRef(false);

    useEffect(() => {
        isDirtyRef.current = isDirty;
    }, [isDirty]);

    const confirmLeave = () => window.confirm("You have unsaved changes. Are you sure you want to leave this page?");

    // Warn user on programmatic in-app navigations (e.g., useNavigate from buttons)
    useEffect(() => {
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;

        const shouldConfirmForUrl = (url) => {
            if (!isDirtyRef.current) return false;
            if (typeof url !== "string") return true;

            try {
                const nextUrl = new URL(url, window.location.href);
                const currentUrl = new URL(window.location.href);
                return !(
                    nextUrl.pathname === currentUrl.pathname &&
                    nextUrl.search === currentUrl.search &&
                    nextUrl.hash === currentUrl.hash
                );
            } catch (_) {
                return true;
            }
        };

        const wrapHistoryMethod = (original) => {
            return function (state, title, url) {
                if (shouldConfirmForUrl(url) && !confirmLeave()) {
                    return;
                }
                // eslint-disable-next-line prefer-rest-params
                return original.apply(this, arguments);
            };
        };

        window.history.pushState = wrapHistoryMethod(originalPushState);
        window.history.replaceState = wrapHistoryMethod(originalReplaceState);

        return () => {
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, []);

    // If the form becomes dirty, insert a single guard entry so the first browser back triggers `popstate`
    // while still staying on the same URL. Then we can confirm and go back once more if user agrees.
    useEffect(() => {
        if (!isDirty) return;
        if (hasBackGuardRef.current) return;

        try {
            window.history.pushState({ __bankDetailsUnsavedGuard: true }, "", window.location.href);
            hasBackGuardRef.current = true;
        } catch (_) {
            // no-op
        }
    }, [isDirty]);

    // Warn user on browser back/forward within the SPA
    useEffect(() => {
        const handlePopState = () => {
            if (!hasBackGuardRef.current) return;

            if (!isDirtyRef.current) {
                window.removeEventListener("popstate", handlePopState);
                window.history.go(-1);
                return;
            }

            const ok = confirmLeave();
            if (ok) {
                window.removeEventListener("popstate", handlePopState);
                window.history.go(-1);
                return;
            }

            // Keep the guard active for the next back attempt
            try {
                window.history.pushState({ __bankDetailsUnsavedGuard: true }, "", window.location.href);
                hasBackGuardRef.current = true;
            } catch (_) {
                // no-op
            }
        };

        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, []);

    // Warn user on in-app navigations triggered by anchor clicks (covers react-router <Link />)
    useEffect(() => {
        const handleClickCapture = (event) => {
            if (!isDirtyRef.current) return;

            const anchor = event.target?.closest?.("a");
            if (!anchor) return;

            // Skip new tab / downloads / javascript:void(0) / hash links
            if (anchor.target && anchor.target !== "_self") return;
            if (anchor.hasAttribute("download")) return;
            const hrefAttr = anchor.getAttribute("href");
            if (!hrefAttr) return;
            if (hrefAttr.startsWith("#")) return;

            let nextUrl;
            try {
                nextUrl = new URL(hrefAttr, window.location.href);
            } catch (_) {
                return;
            }

            // Only confirm for same-origin navigations that would change the URL
            if (nextUrl.origin !== window.location.origin) return;
            const currentUrl = new URL(window.location.href);
            if (
                nextUrl.pathname === currentUrl.pathname &&
                nextUrl.search === currentUrl.search &&
                nextUrl.hash === currentUrl.hash
            ) {
                return;
            }

            const ok = confirmLeave();
            if (!ok) {
                event.preventDefault();
                event.stopPropagation();
            }
        };

        document.addEventListener("click", handleClickCapture, true);
        return () => document.removeEventListener("click", handleClickCapture, true);
    }, []);

    // <-------- change the input feilds ----------->
    const submit_add_bank_details = (e) => {
        set_Error({})
        setIsDirty(true);
        const { name, value } = e.target;
        const fieldError = {}
        if (name === "holder_name" && value.length && !isAlphabetical(value)) {
            fieldError[name] = "Holder name must be alphabetical characters only"
            set_Error({
                ...error,
                ...fieldError
            })
            return;
        }
        if (name === "bank_name" && value.length && !isAlphabetical(value)) {
            fieldError[name] = "Bank name must be alphabetical characters only"
            set_Error({
                ...error,
                ...fieldError
            })
            return;
        }
        if (name === "account_no" && value.length) {
            if (!/^\d+$/.test(value)) {
                fieldError[name] = "Account number must contain only digits."
                set_Error({
                    ...error,
                    ...fieldError
                })
                return;
            }

            else if (value.length < 9) {
                fieldError[name] = "Account number must be at least 9 digits."
                set_Error({
                    ...error,
                    ...fieldError
                })
            }
            else if (value.length > 18) {
                fieldError[name] = "Account number must be at most 18 digits."
                set_Error({
                    ...error,
                    ...fieldError
                })
                return;
            }
        }

        if (name === "retype_account_no" && value.length) {
            if (!/^\d+$/.test(value)) {
                fieldError[name] = "Account number must contain only digits."
                set_Error({
                    ...error,
                    ...fieldError
                })
                return;
            }
            else if (value.length > 18) {
                fieldError[name] = "Account number must be at most 18 digits."
                set_Error({
                    ...error,
                    ...fieldError
                })
                return;
            }
            else if (value !== add_new_bank_details.account_no) {
                fieldError[name] = "Account number must be match"
                set_Error({
                    ...error,
                    ...fieldError
                })
            }
        }
        if (name === "ifsc" && !isIFSCCode(value)) {
            fieldError[name] = "Invalid IFSC format (e.g. HDFC0123456)"
            set_Error({
                ...error,
                ...fieldError
            })
        }

        set_Add_New_Address_Form_Data({
            ...add_new_bank_details,
            [name]: value
        })
    }

    // Warn user on tab close / refresh / leaving the site
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (!isDirty) return;
            e.preventDefault();
            e.returnValue = "";
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isDirty]);

    // <---------- Submit the Address details ------>
    const newError = {}

    const submit_bank_details = async (e) => {
        set_Error({})
        e.preventDefault();
        set_Is_Loading(true)
        for (const [key, value] of Object.entries(add_new_bank_details)) {
            if (key === "holder_name" && !value) {
                newError[key] = `Holder name is required`;
            }
            if (key === "bank_name" && !value) {
                newError[key] = `Bank name is required`;
            }
            if (key === "account_no" && !value) {
                newError[key] = `Account number is required`;
            }
            if (key === "account_no" && value && !/^\d+$/.test(value)) {
                newError[key] = `Account number must contain only digits`;
            }
            if (key === "account_no" && value && (value.length < 9 || value.length > 18)) {
                newError[key] = `Account number must be between 9 to 18 digits`;
            }
            if (key === "retype_account_no" && !value) {
                newError[key] = `Retype account number is required`;
            }
            if (key === "retype_account_no" && value && !/^\d+$/.test(value)) {
                newError[key] = `Account number must contain only digits`;
            }
            if (key === "retype_account_no" && value && (value.length < 9 || value.length > 18)) {
                newError[key] = `Account number must be between 9 to 18 digits`;
            }
            if (key === "account_type" && !value) {
                newError[key] = `Account type is required`;
            }
            if (key === "ifsc" && !value) {
                newError[key] = `IFSC is required`;
            }
            if (key === "ifsc" && value && !isIFSCCode(value)) {
                newError[key] = "Invalid IFSC format (e.g. HDFC0123456)"
            }
            else if (key === "retype_account_no" && value.length && value !== add_new_bank_details.account_no) {
                newError[key] = "Account number must be match"
            }
        }

        if (Object.keys(newError).length > 0) {
            set_Error(newError)
            set_Is_Loading(false)
            return;
        }

        const data = {
            holder_name: add_new_bank_details.holder_name,
            bank_name: add_new_bank_details.bank_name,
            account_no: add_new_bank_details.account_no,
            retype_account_no: add_new_bank_details.retype_account_no,
            account_type: add_new_bank_details.account_type,
            ifsc: add_new_bank_details.ifsc
        }

        try {
            const token = User_Authentication();
            if (!token) {
                set_Is_Loading(false)
                throw new Error("User token not found");
            }
            const response = await Add_Astrologer_Bank_Details(data, { Authorization: `Bearer ${token}` })
            if (response?.data?.status === "200") {
                toast("Bank details added successfully")
                setIsDirty(false);
                set_Is_Loading(false)
            }
            else if (response?.response?.data?.status === "500") {
                set_Is_Loading(false)
                toast.error(response?.response?.data?.message);
            }
            console.log("response", response)
        } catch (error) {
            set_Is_Loading(false)
        }
    }

    // <------------ useEffect ---------->
    useEffect(() => {
        const get_astrologer_bank_details = async () => {
            set_Is_Loading(true)
            try {
                const token = User_Authentication();
                if (!token) {
                    set_Is_Loading(false)
                    throw new Error("User token not found");
                }
                const response = await Get_Astrologer_Bank_Details({ Authorization: `Bearer ${token}` })
                set_Is_Loading(false)
                set_Add_New_Address_Form_Data(response?.data?.data?.bankdata)
                const bankDetail = response?.data?.data?.bankdata || {};
                set_Add_New_Address_Form_Data({
                    holder_name: bankDetail?.holder_name || "",
                    bank_name: bankDetail?.bank_name || "",
                    account_no: bankDetail?.account_no || "",
                    retype_account_no: bankDetail?.retype_account_no || "",
                    account_type: bankDetail?.account_type || "",
                    ifsc: bankDetail?.ifsc || "",
                });
            }
            catch (error) {
                set_Is_Loading(false)
            }
        }
        get_astrologer_bank_details();
    }, [])

    return (
        <div>
            <div>
                {/* <------------ Header ------------> */}
                <AstrologerAfterLoginHeader />
                {/* <-------- ToastContainer ------------> */}
                {
                    is_loading ? (
                        <Loader />
                    ) : (
                        <>
                            <div className="bg-[#f8f8f8] py-8">
                                <div
                                    className=" mx-auto min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                    <div className="myaccount-section w-full">
                                        <div className="container-x mx-auto">
                                            <div className="w-full my-10">
                                                <div className="w-full bg-white shadow-xl p-5">
                                                    <div className=" w-full">
                                                        <h1 className="font-bold text-[24px] text-qblack mb-4">Add Bank Details
                                                        </h1>
                                                        <form method='post' onSubmit={submit_bank_details}>
                                                            <div className="flex space-x-8">
                                                                <div className="w-full">
                                                                    <div className="input-grid flex space-x-2.5 mb-8">
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Holder Name: *</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input placeholder="" onChange={submit_add_bank_details} value={add_new_bank_details?.holder_name} name='holder_name'
                                                                                        className="w-full input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="text" />

                                                                                </div>
                                                                                {error && error.holder_name && (
                                                                                    <p className="text-red-500 text-xs mt-1">{error.holder_name}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Bank Name: *</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input placeholder="" onChange={submit_add_bank_details} value={add_new_bank_details?.bank_name} name='bank_name'
                                                                                        className="w-full input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="text" />
                                                                                </div>
                                                                                {error && error.bank_name && (
                                                                                    <p className="text-red-500 text-xs mt-1">{error.bank_name}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="input-grid flex space-x-2.5 mb-8">
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Account No *</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input placeholder="" onChange={submit_add_bank_details} value={add_new_bank_details?.account_no} name='account_no'
                                                                                        className="w-full input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="number" />
                                                                                </div>
                                                                                {error && error.account_no && (
                                                                                    <p className="text-red-500 text-xs mt-1">{error.account_no}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com "><label
                                                                                className="w-full input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Retype Account No: *</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input placeholder="" onChange={submit_add_bank_details} value={add_new_bank_details?.retype_account_no} name='retype_account_no'
                                                                                        className="input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="number" />
                                                                                </div>
                                                                                {error && error.retype_account_no && (
                                                                                    <p className="text-red-500 text-xs mt-1">{error.retype_account_no}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                    </div>


                                                                    <div className="input-grid flex space-x-2.5 mb-8">
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">IFSC: *</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input placeholder="" onChange={submit_add_bank_details} value={add_new_bank_details?.ifsc} name='ifsc'
                                                                                        className="w-full input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="text" />
                                                                                </div>
                                                                                {error && error.ifsc && (
                                                                                    <p className="text-red-500 text-xs mt-1">{error.ifsc}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com">
                                                                                <label className="input-label capitalize block mb-2 text-qgray text-[13px] font-normal">Account Type: *</label>
                                                                                <div className="input-wrapper border border-qgray-border overflow-hidden relative">
                                                                                    <select onChange={submit_add_bank_details} name="account_type" value={add_new_bank_details?.account_type || ""}
                                                                                        className="input-field placeholder:text-sm text-sm px-6 text-dark-gray font-normal bg-white focus:ring-0 focus:outline-none h-[50px] w-full"

                                                                                    >
                                                                                        <option value="">
                                                                                            Select Account Type
                                                                                        </option>
                                                                                        <option value="savings">Savings</option>
                                                                                        <option value="checking">Current</option>
                                                                                        <option value="business">Business</option>
                                                                                    </select>
                                                                                </div>
                                                                                {error && error.account_type && (
                                                                                    <p className="text-red-500 text-xs mt-1">{error.account_type}</p>
                                                                                )}
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="action-area">
                                                                <button type='submit'
                                                                    className="w-[164px] inline-block text-center py-3 bg-[#9F2225] text-white text-sm">Save Bank Details</button>

                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }
                {/* <--------- Footer section's ----------> */}
                <AstrologerFooter />
            </div>
        </div>
    )
}

export default Astrologer_Bank_Deatils